import { useAuth } from '../../features/auth/auth-context';

import styles from './AppPages.module.css';

function formatTimestamp(value: string | null): string {
  return value === null ? 'Never' : new Date(value).toLocaleString();
}

export function ProfilePage(): React.JSX.Element {
  const { user } = useAuth();

  if (user === null) {
    return <p className={styles.empty}>No profile is loaded.</p>;
  }

  return (
    <div className={styles.page}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Your profile</h1>
      </header>

      <section className={styles.card} aria-labelledby="account-heading">
        <h2 className={styles.cardTitle} id="account-heading">
          Account
        </h2>

        <dl className={styles.definitionList}>
          <dt>Email</dt>
          <dd>{user.email}</dd>

          <dt>Account type</dt>
          <dd>{user.userType === 'CUSTOMER' ? 'Customer' : 'Staff'}</dd>

          <dt>Status</dt>
          <dd>{user.status.replace(/_/g, ' ').toLowerCase()}</dd>

          <dt>Email verified</dt>
          <dd>{formatTimestamp(user.emailVerifiedAt)}</dd>

          <dt>Last sign-in</dt>
          <dd>{formatTimestamp(user.lastLoginAt)}</dd>
        </dl>
      </section>

      <section className={styles.card} aria-labelledby="permissions-heading">
        <h2 className={styles.cardTitle} id="permissions-heading">
          Permissions
        </h2>
        <p className={styles.pageSubtitle}>
          Granted through your roles. The server checks these on every request, so this list is a
          summary rather than the control itself.
        </p>

        {user.permissions.length > 0 ? (
          <ul className={styles.chipList}>
            {user.permissions.map((permission) => (
              <li className={styles.codeChip} key={permission}>
                {permission}
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.empty}>No permissions are granted to this account.</p>
        )}
      </section>
    </div>
  );
}
